module.exports = __webpack_public_path__ + "static/assets/88efda0fbcf0fda96d38861dd672c3e7.svg";